/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */
export const PATIENT_BIRTHDAY_FORMAT = 'yyyy/MM/dd';

export interface PatientDescription {
  readonly surname?: string | null;
  readonly name?: string | null;
  readonly gender?: PatientGender | null;
  readonly age?: number | null;
}

export interface Patient extends PatientDescription {
  readonly patientId?: string | null;
  readonly caseNumber?: string | null;
  readonly height?: number | null;
  readonly weight?: number | null;
  readonly birthday?: string | null;
  readonly street?: string | null;
  readonly postalCode?: string | null;
  readonly city?: string | null;
  readonly policyNumber?: string | null;
  readonly insuranceName?: string | null;
  readonly insuranceNumber?: string | null;
  readonly cardNumber?: string | null;
  readonly cardStatus?: string | null;
  readonly symptomOnset?: string | null;
}

export enum PatientGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN',
}
